import { AlertModule } from "@/interfaces/alert.ts";
import { Message } from "@/interfaces/alert";
import { AlertState } from "@/interfaces/alert";

const alert: AlertModule = {
  namespaced: true,
  state: {
    message: {
      text: "",
      color: "",
      icon: ""
    }
  },
  mutations: {
    setMessage(state: AlertState, data: Message) {
      state.message = data;
    },
    clearMessage(state: AlertState) {
      state.message = {
        text: "",
        color: "",
        icon: ""
      };
    }
  }
};

export default alert;
